import React from 'react';
import MainTitle from './MainTitle';
import Paragraph from './Paragraph';
import SubTitle from './SubTitle';
import InputLabel from './InputLabel';
import Span from './Span';
import ListItem from './ListItem';
import SectionTitle from './SectionTitle';
import SectionSubTitle from './SectionSubTitle';
import HtmlParagraph from './HtmlParagraph';
import NavigationTitle from './NavigationTitle';
import NavigationLink from './NavigationLink';

function Text(props) {
  const { type, ...rest } = props;
  /**
  * span -10-12px
    paragraph-13-16/19px
    sub_title - 19-20/21px
    main_title - 21+px
  */
  switch (type) {
    case 'main_title':
      return <MainTitle {...rest} />;
    case 'sub_title':
      return <SubTitle {...rest} />;
    case 'paragraph':
      return <Paragraph {...rest} />;
    case 'input_label':
      return <InputLabel {...rest} />;
    case 'span':
      return <Span {...rest} />;
    case 'list_item':
      return <ListItem {...rest} />;
    case 'section_title':
      return <SectionTitle {...rest} />;
    case 'section_sub_title':
      return <SectionSubTitle {...rest} />;
    case 'navigation_title':
      return <NavigationTitle {...rest} />;
    case 'html_paragraph':
      return <HtmlParagraph {...rest} />;
    case 'navigation_link':
      return <NavigationLink {...rest} />;
    default:
      return '';
  }
}

export default Text;
